import { useState, useEffect } from 'react';

/* eslint-disable import/prefer-default-export */
const GRAPHQL_URL = __GRAPHQL_URL__; // eslint-disable-line no-undef

const useQuery = ({
  query,
  variables = null,
  token,
  canFetch = true,
  dependencies = [],
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  // eslint-disable-next-line no-param-reassign
  const TIMEOUT_DELAY_MS = 5000;
  useEffect(() => {
    if (!query || !token || !variables || !canFetch) return;
    const controller = new AbortController();
    const { signal } = controller;

    let timeoutId;

    const fetchData = async () => {
      setError(null);
      setLoading(true);

      // Abort the request after timeout
      timeoutId = setTimeout(() => {
        controller.abort();
        setError(new Error(`Request timed out after ${TIMEOUT_DELAY_MS / 1000} seconds`));
      }, TIMEOUT_DELAY_MS);

      try {
        const response = await fetch(GRAPHQL_URL, {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.app.v4+json',
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query,
            ...(variables ? { variables } : null),
          }),
          signal,
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();
        setData(result.data);
      } catch (e) {
        if (e.name === 'AbortError') {
          // eslint-disable-next-line no-console
          console.warn('Request aborted');
        } else {
          // eslint-disable-next-line no-console
          console.error('Error:', e);
          setError(String(e));
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, dependencies);

  return {
    loading,
    error,
    data,
  };
};

export default useQuery;



// WEBPACK FOOTER //
// ./hooks/useQuery.js